import React, { Component } from "react";
import Select from "react-select";
import Button from "components/UI/Button";
import Box from "components/UI/Box";
import FilterItem from "components/FilterItem";
class ExportGyms extends Component {
  constructor() {
    super();
    this.state = {
      activeFilters: ["Retro Fitness", "New York", "Inactive"]
    };
  }

  style = {
    box: {
      width: "900px",
      marginTop: "120px"
    },
    wrapper: {
      display: "flex",
      justifyContent: "center",
      position: "relative"
    },
    header: {
      position: "absolute",
      top: "0px",
      left: "25px"
    },
    headerText: {
      fontSize: "40px",
      color: "#444445",
      fontFamily: "arial",
      letterSpacing: "10px"
    },
    selectors: {
      valueContainer: (base, state) => ({
        ...base,
        display: "flex",
        justifyContent: "center"
      }),
      control: (base, state) => {
        return {
          ...base,
          backgroundColor: "#444445",
          borderRadius: "36px",
          padding: "8px"
        };
      },
      indicatorSeparator: (base, state) => ({
        ...base,
        display: "none"
      }),
      placeholder: (base, state) => ({
        ...base,
        textAlign: "center",
        color: "#fff",
        fontSize: "18px",
        fontFamily: "arial"
      }),
      singleValue: (base, state) => ({
        ...base,
        color: "#fff",
        textAlign: "center",
        fontSize: "18px"
      }),
      dropdownIndicator: (base, state) => ({
        ...base,
        color: "#000"
      }),
      container: (base, state) => ({
        ...base,
        width: "200px"
      })
    },
    selectorsWrapper: {
      display: "flex",
      justifyContent: "space-around"
    },
    button: {
      width: "200px",
      fontFamily: "arial",
      fontSize: "25px",
      margin: "50px 10px"
    },
    filterWrapper: {
      display: "flex",
      marginTop: "25px",
      flexWrap: "wrap"
    }
  };

  options = {
    name: [
      { value: "RetroFitness", label: "RetroFitness" },
      { value: "RetroFitness", label: "RetroFitness" }
    ],
    city: [
      { value: "Kentucky", label: "Kentucky" },
      { value: "NewJersy", label: "New Jersy" }
    ],
    active: [
      { value: "active", label: "Active" },
      { value: "inactive", label: "Inactive" }
    ],
    session: [{ value: "testvalue", label: "Test Label" }]
  };

  selectFilters = selectedOption => {
    let filters = this.state.activeFilters;
    filters.push(selectedOption.label);
    this.setState({
      ...this.state,
      activeFilters: filters
    });
  };

  removeFilter = filter => {
    let filters = this.state.activeFilters;
    filters.splice(this.state.activeFilters.indexOf(filter), 1);
    this.setState({
      ...this.state,
      activeFilters: filters
    });
  };

  componentWillMount() {
    this.filterList = this.state.activeFilters.map((filter, index, array) => {
      return <FilterItem name={filter} crossAction={this.removeFilter} />;
    });
  }
  render() {
    this.filterList = this.state.activeFilters.map((filter, index, array) => {
      return <FilterItem name={filter} crossAction={this.removeFilter} />;
    });
    return (
      <div style={this.style.wrapper}>
        <div style={this.style.header}>
          <p style={this.style.headerText}>Export Details</p>
        </div>
        <Box style={this.style.box} outline>
          <div style={this.style.selectorsWrapper}>
            <Select
              onChange={this.selectFilters}
              isSearchable={false}
              placeholder="Name"
              options={this.options.name}
              styles={this.style.selectors}
            />
            <Select
              onChange={this.selectFilters}
              isSearchable={false}
              placeholder="City"
              options={this.options.city}
              styles={this.style.selectors}
            />
            <Select
              onChange={this.selectFilters}
              isSearchable={false}
              placeholder="Active"
              options={this.options.active}
              styles={this.style.selectors}
            />
            <Select
              onChange={this.selectFilters}
              isSearchable={false}
              placeholder="Session"
              options={this.options.session}
              styles={this.style.selectors}
            />
          </div>
          <div style={this.style.filterWrapper}>{this.filterList}</div>
          <Button type="primary" style={this.style.button}>
            Export
          </Button>
        </Box>
        {/* <ExportModal/> */}
      </div>
    );
  }
}

export default ExportGyms;

